<template>
    <div class="sources-tab">
        <v-row
            align="center"
            class="ma-0 mt-6 mb-4"
            v-if="
                checkRole(project.id, 'project:connector:delete') ||
                checkRole(project.id, 'project:connector:edit')
            "
        >
            <v-spacer></v-spacer>
            <v-btn
                elevation="0"
                color="mainNew"
                class="white--text btn-w-icon"
                @click="$emit('add-connector')"
                v-if="isSuperUser"
            >
                <v-icon class="mr-5px"> mdi-plus </v-icon>Добавить источник
            </v-btn>
            <ChangeViewBtn
                :value="connectorsView"
                @input="updateConnectorsView"
                :cacheKey="'connectorsView'"
                class="ml-4"
            ></ChangeViewBtn>
        </v-row>
        <div v-if="connectorsView === 'cards'" class="cards-grid mt-4">
            <component
                v-for="card in allSourcesCards"
                :is="card.isActive ? 'ConnectorCard' : 'InactiveSourceCard'"
                :key="card.key"
                :connector="card.connector"
                :connectorType="card.connectorType"
                :projectId="project.id"
                :selectedConnectors="selectedConnectors"
                :loading="card.loading"
                @openConnectorSettings="handleOpenConnectorSettings"
                @deleteConnector="handleDeleteConnector"
            ></component>
        </div>
        <ConnectorsListView
            v-if="connectorsView === 'list'"
            :connectors="connectors"
            :allSourcesCards="allSourcesCards"
            :value="selectedConnectors"
            @input="handleSelectedConnectorsUpdate"
            @openConnectorSettings="handleOpenConnectorSettings"
            @deleteConnector="handleDeleteConnector"
        ></ConnectorsListView>
    </div>
</template>

<script>
import { checkRole } from '../../helpers/roles'
import ChangeViewBtn from '@/components/buttons/ChangeViewBtn'
import ConnectorCard from './ConnectorCard'
import InactiveSourceCard from './InactiveSourceCard.vue'
import ConnectorsListView from './ConnectorsListView'
import cfg from '../../../config'

export default {
    name: 'SourcesTab',
    components: {
        ChangeViewBtn,
        ConnectorCard,
        InactiveSourceCard,
        ConnectorsListView,
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
        connectors: {
            type: Array,
            required: true,
        },
        allSourcesCards: {
            type: Array,
            required: true,
        },
        selectedConnectors: {
            type: Array,
            default: () => [],
        },
        connectorsView: {
            type: String,
            default: 'cards',
        },
    },
    computed: {
        isSuperUser() {
            return cfg.adminsWhitelist.includes(this.$auth.user.sub)
        },
    },
    methods: {
        checkRole,
        updateConnectorsView(value) {
            this.$emit('update:connectorsView', value)
            this.$emit('update:selectedConnectors', [])
        },
        handleSelectedConnectorsUpdate(value) {
            this.$emit('update:selectedConnectors', value)
        },
        handleOpenConnectorSettings(connectorId) {
            this.$emit('openConnectorSettings', connectorId)
        },
        handleDeleteConnector(connectorId) {
            this.$emit('deleteConnector', connectorId)
        },
    },
}
</script>

<style scoped>
.sources-tab {
    margin-top: 16px;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    width: 100%;
}

/* только корень карточки — не трогаем иконки/кнопки внутри */
.cards-grid >>> > .connector-card {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box;
}

@media (max-width: 1100px) {
    .cards-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 720px) {
    .cards-grid {
        grid-template-columns: minmax(0, 1fr);
    }
}
</style>

